import { useMemo } from 'react';

import { IntegrationsContextProvider } from '@hotjar/integrations';
import { useFeature } from '@hotjar/webapp/hooks/useFeature';
import { useCurrentSite, useCurrentSiteId, useSites } from '@hotjar/site';
import { usePageTitle } from '@hotjar/webapp/hooks/usePageTitle';
import { useAuthorization } from '@hotjar/webapp/domains/authorization';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

import { INTEGRATIONS, INTEGRATION_DETAILS, BILLING } from '../constants/routes/settings';
import { LIST } from '../constants/routes/team';

interface IntegrationsContextProps {
  children: React.ReactNode;
}

export const IntegrationsContext = ({ children }: IntegrationsContextProps): JSX.Element => {
  const { optimizelyIntegration } = useTrack();
  const integrationsContextObject = useMemo(
    () => ({
      useAuthorization,
      useFeature,
      useCurrentSite,
      useSites,
      routes: {
        integrations: INTEGRATIONS.path,
        integrationDetails: INTEGRATION_DETAILS.path,
        billing: BILLING.path,
        teamList: LIST.path,
      },
      usePageTitle,
      useCurrentSiteId,
      useTrack: () => ({ optimizelyIntegration }),
    }),
    [optimizelyIntegration],
  );

  return (
    <IntegrationsContextProvider value={integrationsContextObject}>
      {children}
    </IntegrationsContextProvider>
  );
};
